import React from 'react';
import { FormattedTextField, DateFieldWithPrefix, createTruncatedTextFormat } from 'framework/ui/field';
import { DATE_FORMAT } from 'framework/utils';
import { AppIcon } from 'framework/ui/mui-builder';
import { EditableListDataGridLayout, EDITABLE_LIST_FIELD } from 'framework/list';

const CriticalPeriodsList = () => {
  return (
    <EditableListDataGridLayout
      getRowEnabled={() => true}
      getTableCells={async isEditModeLayout =>
        Promise.resolve([
          {
            type: EDITABLE_LIST_FIELD,
            source: 'title',
            isEditor: false,
            component: FormattedTextField,
            componentProps: {
              format: createTruncatedTextFormat(40),
            },
            gridCellProps: {
              size: 3,
            },
          },
          {
            type: EDITABLE_LIST_FIELD,
            source: 'startDate',
            isEditor: false,
            component: DateFieldWithPrefix,
            componentProps: {
              tooltipProps: {
                title: 'Start',
                children: (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <AppIcon icon="outlinedCalendar" sx={{ fontSize: '14px', color: 'text.secondary' }} />
                  </div>
                ),
              },
              dateFormat: DATE_FORMAT.FULL_DATE,
            },
            gridCellProps: {
              size: 1.5,
            },
          },
          {
            type: EDITABLE_LIST_FIELD,
            source: 'endDate',
            isEditor: false,
            component: DateFieldWithPrefix,
            componentProps: {
              tooltipProps: {
                title: 'End',
                children: (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <AppIcon icon="outlinedCalendar" sx={{ fontSize: '14px', color: 'text.secondary' }} />
                  </div>
                ),
              },
              dateFormat: DATE_FORMAT.FULL_DATE,
            },
            gridCellProps: {
              size: 1.5,
            },
          },
          {
            type: EDITABLE_LIST_FIELD,
            source: 'description',
            isEditor: false,
            component: FormattedTextField,
            componentProps: {
              format: createTruncatedTextFormat(80),
            },
            gridCellProps: {
              size: 6,
            },
          },
        ])
      }
    />
  );
};

export default CriticalPeriodsList;
